import {
    getRouteIdDPEndLoading,
    getRouteIdDPEndRequest,
    getRouteIdDPEndSuccess,
    getRouteIdDPEndReject,
} from "../../actions/route/getDPEndAll";

export const getRouteIdDPEnd = (formData) => async (dispatch, getState) => {
    dispatch(getRouteIdDPEndLoading());
    try {
        const { data } = await getRouteIdDPEndRequest(formData, getState);
        dispatch(getRouteIdDPEndSuccess(data))
    } catch (error) {
        dispatch(getRouteIdDPEndReject(error))
    }
    return Promise.resolve();
};